import React from 'react';
import { LucideIcon } from 'lucide-react';

interface QuickActionCardProps {
  title: string;
  description?: string;
  onClick: () => void;
  image?: string;
  icon?: LucideIcon;
  iconColor?: string;
  iconBgColor?: string;
}

export const QuickActionCard: React.FC<QuickActionCardProps> = ({
  title,
  description,
  onClick,
  image,
  icon: Icon,
  iconColor = '#4A3CFA',
  iconBgColor = 'rgba(74, 60, 250, 0.08)',
}) => {
  return (
    <div className="quick-action-card" onClick={onClick}>
      {image ? (
        <div className="quick-action-image">
          <img src={image} alt={title} />
        </div>
      ) : Icon ? (
        <div 
          className="quick-action-icon" 
          style={{ backgroundColor: iconBgColor }}
        >
          <Icon size={20} color={iconColor} />
        </div>
      ) : null}
      <div className="quick-action-text">
        <span className="quick-action-title">{title}</span>
        {description && <span className="quick-action-description">{description}</span>}
      </div>
    </div>
  );
};
